import {events} from "../bootstrap/components/events";
import * as parsis from "../bootstrap/components/parsis"

export const SearchBarApp = function (config, $) {
    const app = this;

    const lastKeyChangedTimeout = 500;

    let lastKeyChanged = '';
    let lastKeyChangedTimeoutId = null;
    let ajax = null;

    app.elms = {};
    app.elms.$wrap = $$(config.wrapId);
    app.elms.$form = app.elms.$wrap.search('form');
    app.elms.$container = app.elms.$wrap.search('container');
    app.elms.$loading = app.elms.$wrap.search('loading');
    app.elms.$list = app.elms.$wrap.search('list');

    const components = new function () {
        const _component = this;

        _component.heading = (title) => `<div class="search-bar-heading"><strong>${title}</strong></div>`;

        _component.item = (data) => `<div class="search-bar-item">
                    <a href="${data.permalink}" target="_blank" class="search-bar-item-label">${data.title}</a>
                </div>`;

        _component.empty = () => `<p class="search-bar-empty"><i>No items found, please try with another keyword or filter.</i></p>`;
    }

    function search() {
        const data = app.elms.$form.serializeArray();
        data.push({name: 'highlight', value: true});

        ajax && ajax.abort && ajax.abort();

        ajax = $.ajax({
            url         : app.elms.$form.attr('action'),
            method      : app.elms.$form.attr('method'),
            data        : data,
            beforeSend  : () => { app.elms.$loading.addClass('show') },
            complete    : () => { app.elms.$loading.removeClass('show') },
            success     : (res) => {
                app.elms.$list.html('');

                if (res && res.data) {

                    if ( res.data.products ) {
                        app.elms.$list.append( components.heading('Products: ') );
                        for (let i in res.data.products)
                            app.elms.$list.append( components.item(res.data.products[i]) );
                    }

                    if ( res.data.pages ) {
                        app.elms.$list.append( components.heading('Pages: ') );
                        for (let i in res.data.pages)
                            app.elms.$list.append( components.item(res.data.pages[i]) );
                    }

                    if ( res.data.posts ) {
                        app.elms.$list.append( components.heading('Blog: ') );
                        for (let i in res.data.posts)
                            app.elms.$list.append( components.item(res.data.posts[i]) );
                    }
                } else
                    app.elms.$list.html( components.empty() );

                app.elms.$container.addClass('show');
            },
            error       : (e) => { console.error( e ) }
        });
    }

    app.keywordChanged = (el, e) => {

        if (e.type === 'focus' || e.type === 'click') {

            if ( app.elms.$list.children().length ) {
                app.elms.$container.addClass('show');
            }

            e.stopPropagation();

        }
        else {
            if ( el.value !== lastKeyChanged ) {
                lastKeyChanged = el.value;

                lastKeyChangedTimeoutId = setTimeout(()=> {

                    search();
                    clearTimeout( lastKeyChangedTimeoutId );

                }, lastKeyChangedTimeout);
            }
        }
    }

    app.taxonomyChanged = () => { search() }

    app.init = function () {

        events.bind(app.elms.$wrap, app);

        $(document).on('click', function () {
            app.elms.$container.removeClass('show');
        })

        return app;
    }
}